import React from "react";
import { Link } from "react-router-dom";
import logo from "./assets/logo.png";

const Footer = () => {
  return (
    <footer className="border-t border-slate-900/10 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        {/* Top row: logo + nav links */}
        {/* Top row: logo + nav links */}
        <div className="flex sm:flex-row justify-around sm:justify-between sm:items-center gap-4 pb-2">
          <Link to="/" className="flex items-center">
            <img src={logo} alt="Jindo Logo" className="h-7 sm:h-8 w-auto" />
          </Link>

          <nav className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-x-6 sm:gap-y-2 text-xs sm:text-sm">
            <Link
              to="/privacy"
              className="text-slate-600 hover:text-jindo-orange font-medium transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-service"
              className="text-slate-600 hover:text-jindo-orange font-medium transition-colors"
            >
              Terms of Service
            </Link>
            <Link
              to="/google-api-disclosure"
              className="text-slate-600 hover:text-jindo-orange font-medium transition-colors"
            >
              Google API Disclosure
            </Link>
            <Link
              to="/microsoft-api-disclosure"
              className="text-slate-600 hover:text-jindo-orange font-medium transition-colors"
            >
              Microsoft API Disclosure
            </Link>
          </nav>
        </div>

        {/* Bottom row: copyright */}
        <div className="pt-2 text-xs sm:text-sm text-slate-400 text-center">
          © 2026 Jindo Labs. All rights reserved. US patent pending technology.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
